import type { IconData } from '@stacksjs/iconify-core'

export const attributionFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M1.5 24.063c0-12.427 10.074-22.5 22.5-22.5s22.5 10.073 22.5 22.5s-10.074 22.5-22.5 22.5s-22.5-10.074-22.5-22.5\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M26.97 19.547a4.79 4.79 0 1 0-5.94 0c-2.88.313-5.03 2.65-5.03 5.624c0 1.622.202 2.728.349 3.32c.084.338.302.618.629.74c.41.154 1.134.357 2.344.516c.2 1.852.518 3.99 1.015 5.776c.143.511.508.928 1.015 1.085A9 9 0 0 0 24 37a9 9 0 0 0 2.647-.392c.507-.157.873-.574 1.015-1.085c.498-1.786.815-3.924 1.015-5.776c1.211-.159 1.935-.362 2.345-.516c.327-.123.545-.402.629-.74c.147-.591.349-1.698.349-3.32c0-2.974-2.15-5.311-5.03-5.624\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default attributionFlat
